// ─────────────────────────────────────────────
//  SECTORS DATA
//  Edit this file to update the Sectors section.
//  Each object = one sector tile on the website.
// ─────────────────────────────────────────────

const sectors = [
  {
    id: 1,
    label: 'Data Centers',
    icon: 'datacenter',
  },
  {
    id: 2,
    label: 'Commercial Office',
    icon: 'office',
  },
  {
    id: 3,
    label: 'Industrial Facilities',
    icon: 'industrial',
  },
  {
    id: 4,
    label: 'Healthcare',
    icon: 'healthcare',
  },
];

export default sectors;
